module.exports = __webpack_public_path__ + "static/media/18-sjlvsagt.869bd5e4.mp3";